export default __webpack_public_path__ + "static/media/logo-enterprise.9d44b256.png";